<template>
  <div id="app" class="phone">
    <div class="wrapper">
      <router-view name="header" />
      <router-view />
    </div>
  </div>
</template>

<script>
import { getAnalytics, logEvent } from "firebase/analytics";
import { getApp } from "firebase/app";

export default {
  name: "App",
  data() {
    return {
      notificationPermission: null,
      analytics: null
    };
  },
  async created() {
    try {
      // Initialize analytics
      this.analytics = getAnalytics(getApp());
      await this.initializePushNotifications();
      this.trackUTMParams();
    } catch (error) {
      console.error("Initialization error:", error);
    }
  },
  methods: {
    async initializePushNotifications() {
      try {
        if (!this.$OneSignal) {
          console.warn("OneSignal not initialized");
          return;
        }

        this.notificationPermission = await this.$OneSignal.Notifications
          .permission;

        if (this.notificationPermission === "default") {
          const userConsent = confirm("Enable notifications?");
          if (userConsent) {
            await this.$OneSignal.Notifications.requestPermission();
            logEvent(this.analytics, "notification_opt_in");
          }
        }

        this.$OneSignal.Notifications.addEventListener(
          "click",
          this.handleNotificationClick
        );
        this.$OneSignal.Notifications.addEventListener(
          "foregroundWillDisplay",
          this.handleForegroundNotification
        );
      } catch (error) {
        console.error("Push notification error:", error);
        logEvent(this.analytics, "notification_init_error", {
          error: error.message
        });
      }
    },

    trackUTMParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const utmSource = urlParams.get("utm_source") || "direct";

      logEvent(this.analytics, "utm_tracking", {
        utm_source: utmSource,
        page_path: this.$route.path
      });
    },

    handleNotificationClick(event) {
      logEvent(this.analytics, "notification_click", {
        notification_id: event.notification.id,
        url: event.url || "none"
      });

      if (event.url) window.open(event.url, "_blank");
    },

    handleForegroundNotification(event) {
      logEvent(this.analytics, "notification_received", {
        notification_id: event.notification.id
      });

      this.showCustomNotification(event.notification);
      event.preventDefault();
    },

    showCustomNotification(notification) {
      console.log("Custom notification:", notification);
    }
  },
  beforeDestroy() {
    if (this.$OneSignal) {
      this.$OneSignal.Notifications.removeEventListener(
        "click",
        this.handleNotificationClick
      );
      this.$OneSignal.Notifications.removeEventListener(
        "foregroundWillDisplay",
        this.handleForegroundNotification
      );
    }
  }
};
</script>

<style scoped>
.phone {
  max-width: 500px;
  margin: 0 auto;
  background: #fff;
  min-height: 100vh;
}
.wrapper {
  padding: 10px;
}
</style>
